export const getCardBgColor = ({
  cardVariation,
  isOdd,
  customColor,
}: {
  cardVariation?: string;
  isOdd?: boolean;
  customColor?: string;
}) => {
  return cardVariation === 'product'
    ? `var(--color-emphasize, ${customColor ?? 'none'})`
    : cardVariation === 'articleImage'
      ? `var(--color-secondary, ${customColor ?? 'none'})`
      : isOdd
        ? '#EFDBB2'
        : '#E1B87F';
};
